var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_398",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29215",
    "data-name": "Group 29215",
    transform: "translate(64 11197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -64, -11197)",
    filter: "url(#Ellipse_398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_398-2",
    "data-name": "Ellipse 398",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_10_",
    "data-name": "svgexport-17 (10)",
    transform: "translate(-41.802 -11177.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49874",
    "data-name": "Path 49874",
    d: "M28.431,176.248l-2.279-13.219H2.454L.175,176.248a11.5,11.5,0,0,0-.156,2.616c.075,1.287.3,2.926.954,2.926h26.66c.656,0,.879-1.639.953-2.926a11.467,11.467,0,0,0-.156-2.616",
    transform: "translate(-0.001 -154.636)",
    fill: "#894b9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49875",
    "data-name": "Path 49875",
    d: "M152.169,165h-1.79a.586.586,0,0,1-.586-.586V163.03h2.962v1.389a.586.586,0,0,1-.586.586m-1.389,3.456h.987V165h-.987Z",
    transform: "translate(-141.415 -154.637)",
    fill: "#69357c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49876",
    "data-name": "Path 49876",
    d: "M144.911,253.281a1.975,1.975,0,1,1-1.975-1.975,1.975,1.975,0,0,1,1.975,1.975",
    transform: "translate(-133.077 -237.976)",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49877",
    "data-name": "Path 49877",
    d: "M10.352,28.76H9.364a.494.494,0,1,1,0-.987h.987a.494.494,0,0,1,0,.987m12.281-7.406c-.5-3.1-2.673-8.393-7.838-8.393S7.457,18.25,6.957,21.354H8.974A12.765,12.765,0,0,1,10.022,18.3c1.128-2.231,2.735-3.362,4.773-3.362s3.645,1.131,4.773,3.362a12.764,12.764,0,0,1,1.048,3.057Zm-20.18,0L.173,34.573a11.5,11.5,0,0,0-.156,2.616,8.265,8.265,0,0,0,.409,2.4l.051.034s4.443-3.785,4.443-18.267Zm23.7,0,2.279,13.219a11.5,11.5,0,0,1,.156,2.616,8.265,8.265,0,0,1-.409,2.4l-.051.034s-4.443-3.785-4.443-18.267Z",
    transform: "translate(0 -12.961)",
    fill: "#69357c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag);
export default __webpack_public_path__ + "static/media/Handbag.70bdb7fd59d72ef65721a3020a3e7df0.svg";
export { ForwardRef as ReactComponent };